import classof$1 from './classof.js';
import getMethod$1 from './get-method.js';
import iterators from './iterators.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var classof = classof$1;
var getMethod = getMethod$1;
var Iterators = iterators;
var wellKnownSymbol = wellKnownSymbol$1;
var ITERATOR = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
};

export { getIteratorMethod as default };
